var React = require('react');

function IconLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M610.9 652.5c3 3 3.1 7.9.1 10.9L316.5 958c-3 3-7.9 3-10.9-.1L66.3 718.7c-3-3-3.1-7.9-.1-10.9l294.5-294.5c3-3 7.9-3 10.9.1l95 95 41.7-41.7-95-95c-3-3-3.1-7.9-.1-10.9L707.9 66.1c3-3 7.9-3 10.9.1l239.3 239.3c3 3 3.1 7.9.1 10.9L663.6 610.9c-3 3-7.9 3-10.9-.1l-97-97-41.7 41.8 96.9 96.9zM371.4 508.1L161.6 717.9l144 145L517.3 654l-50.9-50.9-68.7 68.7-47.3-47.3 68.7-68.7-47.7-47.7zm281.3 7.7l211.7-208.9L718.5 161 508.7 370.8l47.5 47.8 57.3-57.3 47.3 47.3-57.5 57.5 49.4 49.7z"}));
}

IconLink.displayName = "IconLink";

IconLink.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconLink;

IconLink.default = IconLink;
